export default __webpack_public_path__ + "static/media/IconUser.36ae7cfc.svg";